/**
 * Who is allowed to see/target which clients' notifications.
 *
 * GSPOS is the super-admin role — it manages alerts for every client. Any other role
 * is pinned to its own client, both when listing and when creating.
 */

export const isSuperAdmin = () => String(localStorage.getItem('role') || '').trim().toUpperCase() === 'GSPOS';

export const getOwnClientId = () => String(localStorage.getItem('clientid') || '').trim();

/**
 * Query params for the list call. A non-GSPOS user with no client id on record gets
 * client_id '0', which matches nothing — failing closed beats listing every client.
 */
export const getNotificationScope = () => {
    if (isSuperAdmin()) return {};
    return { client_id: getOwnClientId() || '0' };
};
